<div class="tooltip-progress-bar-container">
    <div class="tooltip-content">
        <div class="tooltip-title">{{ title }}</div>

        <div class="counters-wrapper">
            <app-ui-icon-number-text-widget
                    [numberValue]="controllersRiskScore"
                    [title]="riskTexts.controllers_modules_assets"
                    [variant]="controllersRiskScoreVariant"
                    [withDenominator]="false"
                    [size]="iconNumberTextItemSize.small"
            ></app-ui-icon-number-text-widget>
            <app-ui-icon-number-text-widget
                    [numberValue]="networkAssetsRiskScore"
                    [title]="riskTexts.network_assets"
                    [variant]="networkAssetsRiskScoreVariant"
                    [withDenominator]="false"
                    [size]="iconNumberTextItemSize.small"
            ></app-ui-icon-number-text-widget>
            <app-ui-icon-number-text-widget
                    [numberValue]="iotRiskScore"
                    [title]="riskTexts.iot_assets"
                    [variant]="iotRiskScoreVariant"
                    [withDenominator]="false"
                    [size]="iconNumberTextItemSize.small"
            ></app-ui-icon-number-text-widget>
        </div>
    </div>
</div>
